import { type FC } from "react"

import { type SubscriptionPaymentInterval } from "@forento/core/models/payment"

import Button from "~/components/Button"
import { CheckmarkIcon } from "~/components/Icon"

type Props = {
	id: number | null
	title: string
	description: string
	usps: string[]
	price: { amount: number; interval: SubscriptionPaymentInterval } | null
	onSelect(): void
	submittingPlanId?: number
}

const Plan: FC<Props> = ({ id, title, description, usps, price, onSelect, submittingPlanId }) => (
	<div className="flex w-80 shrink-0 flex-col rounded-2xl border border-slate-200 bg-white p-6 shadow-[0_12px_16px_-4px_rgba(16,24,40,0.1),0_4px_6px_-2px_rgba(16,24,40,0.05)]">
		<h2 className="text-primary mb-4 text-center text-2xl font-bold">{title}</h2>
		<p className="mb-1 text-center text-4xl leading-none font-semibold text-slate-950">
			{price !== null ? (
				<>
					${price.interval === "year" ? price.amount / 12 : price.amount}
					<span className="text-lg font-normal">/month</span>
				</>
			) : (
				"Free"
			)}
		</p>
		<p className="mb-4 text-center text-sm text-slate-600">{price === null ? 20 : 0}% sales commission</p>
		<p className="mb-4 text-center text-sm text-slate-600">{description}</p>
		<hr className="mb-4 w-full border-t border-slate-200" />
		<div className="mb-4 flex flex-1 flex-col gap-2">
			{usps.map((usp, index) => (
				<div key={index} className="flex gap-2">
					<div className="flex size-5 shrink-0 items-center justify-center rounded-full bg-[#f4ebff]">
						<CheckmarkIcon className="text-primary size-3" />
					</div>
					<p className="text-sm text-slate-700">{usp}</p>
				</div>
			))}
		</div>
		{price !== null ? (
			<Button
				variant="primary"
				onClick={onSelect}
				isDisabled={submittingPlanId !== undefined}
				isLoading={submittingPlanId === id}
				className="rounded-xl"
			>
				Start 30-day free trial
			</Button>
		) : (
			<Button variant="primary" isDisabled className="rounded-xl">
				Currently active
			</Button>
		)}
	</div>
)

export default Plan
